<template>
  <div class="home parent">
    <div class="left l-child">
      <left-menu @meunChenge="getRecentMessage"></left-menu>
    </div>
    <div class="left-fixed-right-auto r-child" v-loading="$store.state.global.loading">
      <head-nav></head-nav>
      <div class="right-content" :style="{height: contentHeight, 'overflow-x': overFlowMode, padding: padding}" id="right-content">
        <div class="pannel-back" :style="{'min-width': minWidth}">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" />
        </div>
        <message-dialog
          :msg-show.sync="msgShow"
          :message-head.sync="messageHead"
          :synopsis.sync="synopsis"
          :picture-url.sync="pictureUrl"
          :message-notify-id.sync="messageNotifyId"
          >
        </message-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { log } from 'util';
import HeadNav from './headNav/index.vue';
import LeftMenu from './leftMenu/index.vue';
import MessageDialog from '../components/MessageDialog.vue';

export default {
  name: 'home',
  data() {
    return {
      headerHeight: 68,
      contentHeight: 300,
      minWidth: '1060px',
      padding: '10px',
      msgShow: false,
      messageHead: '', // 通知标题
      synopsis: '', // 通知简介
      pictureUrl: '',
      messageNotifyId: 0,
    };
  },
  components: {
    HeadNav,
    LeftMenu,
    MessageDialog,
  },
  created() {
  },
  computed: {
    overFlowMode() {
      if (this.$route.name === 'outMedicalRecord') {
        this.minWidth = 'auto';
        this.padding = '10px 0px 10px 10px';
        return 'inherit';
      } else {
        this.minWidth = '1060px';
        this.padding = '10px';
        return 'auto';
      };
    },
  },
  methods: {
    getHeight() {
      let clientHeight = 0;
      const bodyHeight = document.body.clientHeight;
      const docHeight = document.documentElement.clientHeight;
      if (bodyHeight && docHeight) {
        clientHeight = (bodyHeight < docHeight) ? bodyHeight : docHeight;
      } else {
        clientHeight = (bodyHeight > docHeight) ? bodyHeight : docHeight;
      }
      return clientHeight - this.headerHeight - 3;
    },
    getRecentMessage() {
      this.$api.global.getRecentMessage().then((res) => {
        if (res) {
          this.msgShow = true;
          this.messageHead = res.messageHead; // 通知标题
          this.synopsis = res.synopsis; // 通知简介
          this.pictureUrl = res.pictureUrl;
          this.messageNotifyId = res.messageNotifyId;
        }
      });
    },
  },
  mounted() {
    // 初始化窗口监听函数
    window.onresize = () => {
      this.$store.commit('setWindowHeight', this.getHeight());
      this.contentHeight = this.getHeight() + 'px';
    }
    this.contentHeight = this.getHeight() + 'px';
    this.$store.commit('setWindowHeight', this.getHeight());
    this.getRecentMessage();

  },
};
</script>
<style lang="scss">
  .parent {
    background-color: #f5f5f5;
    overflow: hidden;
    width: 100%;
  }

  .l-child {
    float: left;
    width: 200px;
    background: #bbb;
    z-index: 10000;
  }

  .r-child {
    margin-left: 200px;
    background: rgb(245, 245, 245);
  }
  
  .right-content {
    background-color: #f5f5f5;
    padding: 10px;
    box-sizing: border-box;
    overflow-x: auto;
    position: relative;
    width: 100%;
  }
  .pannel-back {
    margin-bottom: 80px;
    height: 100%;
  }
</style>
